export default [
  {
    path: '/admin/defines/districts',
    name: 'Districts',
    component: () => import('@/views/Admin/Defines/Districts/Index.vue'),
    meta: {
      pageTitle: 'İlçeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/districts/add',
    name: 'DistrictAdd',
    component: () => import('@/views/Admin/Defines/Districts/Add.vue'),
    meta: {
      pageTitle: 'İlçeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/districts',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/districts/edit/:id',
    name: 'DistrictEdit',
    component: () => import('@/views/Admin/Defines/Districts/Edit.vue'),
    meta: {
      pageTitle: 'İlçeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/districts',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
